export const environment = {
  production: true,
  buildId: '2825762845019421',
  configFile: 'config.json',
};
